import React from 'react';
import { v4 as uuid } from 'uuid';
import { getFilters } from './Storage/getFilters';
import { sleep } from '../helpers/sleep';

class LoadMoreComponent extends React.Component {
    constructor() {
        super();

        this.loadMore = this.loadMore.bind(this);
        this.forceRun = this.forceRun.bind(this);
        this.callQuery = this.callQuery.bind(this);
        this.checkMaxMin = this.checkMaxMin.bind(this);
        this.handleMoodeChange = this.handleMoodeChange.bind(this);
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));

        this.state = {
            loading: true,
            loadMore: false,
            offset: 0,
            allData: [],
            isShowMore: false,
            filters: getFilters(),
            status: 'all',
            isDark: !!isDark,
        };
    }

    async callQuery() {
        this.query.bind(this.setState.bind(this));
        await this.query.update();
    }

    async checkMaxMin() {
        if (!window.waitMinMax) return this.callQuery();

        if (!window.minMaxDates) {
            await sleep(1000);
            return this.checkMaxMin();
        }

        this.callQuery();
    }

    async componentDidMount() {
        if (this.query) {
            await sleep(0);
            this.checkMaxMin();
        }
    }

    async loadMore(attr) {
        const { query, offsetStep } = attr;
        const oldOffset = this.state.offset ?? 0;
        const newOffset = oldOffset + offsetStep;
        this.setState({
            loadMore: true,
        });
        this.query = query({ offset: newOffset, ...attr });
        this.query.bind(this.setState.bind(this));
        this.setState({
            offset: newOffset,
        });

        await this.query.update();
        this.setState({ loadMore: false });
    }

    componentDidUpdate(prevProps, prevState) {
        document.addEventListener('changeMoodEvent', this.handleMoodeChange);

        const filters = getFilters();
        const data = this.state.data?.map((x) => ({ id: uuid(), ...x }));
        if (prevState.filters !== filters && !this.state.loading) {
            return this.setState({ allData: data, filters });
        }
        if (
            JSON.stringify(this.state.data) !== JSON.stringify(prevState.data) &&
            !this.state.loading
        ) {
            this.setState({ allData: [...this.state.allData, ...data] });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('changeMoodEvent', this.handleMoodeChange);
    }

    handleMoodeChange() {
        const isDark = JSON.parse(localStorage.getItem('dark-mode'));
        this.setState({ isDark });
    }

    forceRun() {
        if (this.query) {
            this.setState({
                allData: [],
                data: [],
            });

            this.query.bind(this.setState.bind(this));
            this.query.update({ force: true, alreadyInQueue: true });
        }
    }
}

export default LoadMoreComponent;
